module.exports = __webpack_public_path__ + "img/image-2.a159dd6f.jpg";